<div
  class="kl-field dk-date-time-picker"
  [class.kl-field--my-3]="marginY()"
  [class.kl-field--mb-2]="marginBottom()"
  [formGroup]="formGroup()">
  @if (label()) {
    <kl-label
      [label]="label()"
      [labelDescription]="labelDescription()"
      [isRequired]="required()"
      [htmlFor]="dateFieldId()" />
  }

  <div class="kl-field__control dk-date-time-picker__row row g-3">
    <div class="dk-date-time-picker__date" [class]="'col-' + dateCols()">
      <p-datepicker
        [inputId]="dateFieldId()"
        [formControlName]="dateControlName()"
        [showIcon]="showIcon()"
        [iconDisplay]="iconDisplay()"
        [showClear]="showClear()"
        [showOnFocus]="showOnFocus()"
        [appendTo]="appendTo()"
        [fluid]="true"
        [placeholder]="effectiveDatePlaceholder()"
        [minDate]="minDate()"
        [maxDate]="maxDate()"
        [dateFormat]="effectivePrimeDateFormat()"
        [pInputMask]="effectiveDateMask()"
        panelStyleClass="kl-datepicker-panel"
        [class.p-invalid]="showInvalid()"
        (onSelect)="onDateSelect()" />
    </div>

    <div class="dk-date-time-picker__time" [class]="'col-' + timeCols()">
      <p-datepicker
        [inputId]="timeFieldId()"
        [(ngModel)]="timePickerValue"
        [ngModelOptions]="{ standalone: true }"
        [disabled]="!!timeControl()?.disabled"
        [timeOnly]="true"
        [showTime]="true"
        [showSeconds]="showSeconds()"
        [hourFormat]="hourFormat()"
        [showIcon]="showIcon()"
        [iconDisplay]="iconDisplay()"
        [showClear]="showClear()"
        [showOnFocus]="showOnFocus()"
        [appendTo]="appendTo()"
        [fluid]="true"
        panelStyleClass="kl-datepicker-panel"
        [class.p-invalid]="showInvalid()"
        (ngModelChange)="onTimeSelect()"
        (onSelect)="onTimeSelect()"
        (onClear)="onTimeClear()" />
    </div>
  </div>

  <div class="kl-field__error text-start">
    @if (showFieldError() && controlError()) {
      <span>{{ controlError() }}</span>
    }
  </div>
</div>
